export enum ServerError {
  ORGANIZATION_IS_REQUIRED = 'organization is required',
  VENUES_MUST_BE_AN_ARRAY = 'venues must be an array',
  FIRST_NAME_IS_REQUIRED = 'firstName is required',
  LAST_NAME_IS_REQUIRED = 'lastName is required',
  ORGANIZATION_NOT_FOUND = 'organization not found',
  VENUE_NOT_FOUND = 'venue not found',
}
